import {
  HomeOutlined, ClockCircleOutlined, DollarOutlined, ContainerOutlined, NotificationOutlined,
  MenuFoldOutlined, MenuUnfoldOutlined, BookOutlined, PoundOutlined, InboxOutlined, FileTextOutlined,
  GatewayOutlined, FileDoneOutlined, FileOutlined, TeamOutlined, SettingOutlined, AppstoreOutlined,
  FormOutlined, SafetyCertificateOutlined, CloseOutlined
} from '@ant-design/icons';
import { Layout, Menu, Button, Drawer, Badge, Typography } from 'antd';
import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useI18n } from '../../../../Utils/i18n';

const { Sider } = Layout;
const { Text } = Typography;

const iconMap = {
  home: <HomeOutlined />, form: <FormOutlined />, paper: <FileOutlined />, approval: <FileDoneOutlined />,
  report: <FileTextOutlined />, master: <AppstoreOutlined />, book: <BookOutlined />, team: <TeamOutlined />,
  settings: <SettingOutlined />, membership: <TeamOutlined />, penjualan: <InboxOutlined />,
  meeting: <GatewayOutlined />, benefit: <PoundOutlined />, absen: <ClockCircleOutlined />,
  kpi: <FileDoneOutlined />, salary: <DollarOutlined />, notification: <NotificationOutlined />,
  loan: <ContainerOutlined />, warning: <SafetyCertificateOutlined />,
  wlm: <SafetyCertificateOutlined />, wla: <SafetyCertificateOutlined />,
  delegation: <FileDoneOutlined />, asset: <ContainerOutlined />,
};

function MenuSideBars() {
  const selector = useSelector((state) => state.user);
  const { language, translate } = useI18n();
  const navigate = useNavigate();
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(() => typeof window !== 'undefined' && window.innerWidth < 992);
  const [menus, setMenus] = useState([]);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 992;
      setIsMobile(mobile);
      if (!mobile) setMobileOpen(false);
    };
    window.addEventListener('resize', handleResize, { passive: true });
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    let role = { role_menu: [] };
    try { role = JSON.parse(selector.menu) || role; } catch (_) { /* menu kosong */ }

    const roleMenus = Array.isArray(role.role_menu) ? role.role_menu : [];
    const mappedMenus = [...roleMenus]
      .filter((item) => item?.menu)
      .sort((a, b) => Number(a.menu.sequence || 0) - Number(b.menu.sequence || 0))
      .map((mn) => {
        let childSource = (mn.role_submenu || [])
          .filter((sub) => sub?.submenu)
          .sort((a, b) => Number(a.submenu.sequence || 0) - Number(b.submenu.sequence || 0));

        const children = childSource.map((sub) => ({
          key: sub.submenu.link,
          label: (
            <span className="app-menu-label">
              <span>{translate(sub.submenu.submenu)}</span>
              {sub.submenu.has_notification ? <Badge dot /> : null}
            </span>
          ),
        }));

        return {
          key: mn.menu.link,
          icon: iconMap[mn.menu.icon] || <AppstoreOutlined />,
          label: (
            <span className="app-menu-label">
              <span>{translate(mn.menu.menu)}</span>
              {mn.menu.has_notification ? <Badge dot /> : null}
            </span>
          ),
          ...(children.length ? { children } : {}),
        };
      });

    // Tidak ada menu hardcode. My Warning Letter dan Manage Warning Letters
    // mengikuti role_menu dari API/database seperti menu lainnya.
    setMenus(mappedMenus);
  }, [selector.menu, language, translate]);

  const currentKey = location.pathname.replace(/^\//, '');

  const openKeys = useMemo(() => {
    const parent = menus.find((item) => item.children?.some((child) => child.key === currentKey));
    return parent ? [parent.key] : [];
  }, [menus, currentKey]);

  const onMenuClick = ({ key }) => {
    navigate('/' + key);
    if (isMobile) setMobileOpen(false);
  };

  const menuNode = (
    <Menu
      mode="inline"
      selectedKeys={[currentKey]}
      defaultOpenKeys={openKeys}
      className="app-sidebar__menu"
      items={menus}
      onClick={onMenuClick}
      inlineIndent={18}
    />
  );

  return (
    <>
      {!isMobile && (
        <Sider
          className="app-sidebar"
          collapsed={collapsed}
          width={248}
          collapsedWidth={76}
          theme="light"
          trigger={null}
        >
          <div className="app-sidebar__top">
            {!collapsed && <Text className="app-sidebar__title">{translate('Navigation')}</Text>}
            <Button
              type="text"
              className="app-sidebar__collapse-btn"
              aria-label={collapsed ? 'Perbesar sidebar' : 'Perkecil sidebar'}
              icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
              onClick={() => setCollapsed(!collapsed)}
            />
          </div>
          {menuNode}
        </Sider>
      )}

      {isMobile && (
        <Button
          type="primary"
          className="mobile-menu-button"
          aria-label="Buka menu navigasi"
          icon={<MenuUnfoldOutlined />}
          onClick={() => setMobileOpen(true)}
        />
      )}

      <Drawer
        title={<span className="mobile-nav-drawer__title">{translate('Navigation')}</span>}
        placement="left"
        closeIcon={<CloseOutlined />}
        onClose={() => setMobileOpen(false)}
        open={isMobile && mobileOpen}
        width="min(88vw, 340px)"
        className="mobile-nav-drawer"
        styles={{ body: { padding: 8 } }}
      >
        {menuNode}
      </Drawer>
    </>
  );
}

export default MenuSideBars;
